export const TagIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_23849_22603)">
        <path
          d="M7.64585 0.676514C8.10359 0.722064 8.53391 0.924547 8.862 1.25269L14.666 7.05672C15.0912 7.48463 15.3301 8.0635 15.3301 8.66675L15.3275 8.77938C15.2998 9.34165 15.0647 9.87557 14.666 10.2768L10.2767 14.6661C9.87551 15.0648 9.34159 15.2998 8.77932 15.3276L8.66669 15.3302C8.06344 15.3302 7.48457 15.0913 7.05666 14.6661L1.25262 8.86206C0.924486 8.53397 0.722003 8.10365 0.676453 7.64591L0.666687 7.448V2.66675C0.666687 2.13632 0.877552 1.62776 1.25262 1.25269C1.6277 0.877613 2.13625 0.666748 2.66669 0.666748H7.44794L7.64585 0.676514ZM2.66669 2.00008C2.48988 2.00008 2.32036 2.07037 2.19533 2.19539C2.07031 2.32042 2.00002 2.48994 2.00002 2.66675V7.448L2.00328 7.51375C2.01844 7.66638 2.08591 7.80996 2.19533 7.91935L7.99676 13.7208L8.06643 13.7833C8.23526 13.9208 8.44705 13.9968 8.66669 13.9968L8.76044 13.9923C8.97703 13.9708 9.18083 13.8755 9.33661 13.7208L13.722 9.33537C13.876 9.17976 13.9708 8.97648 13.9922 8.7605L13.9968 8.66675C13.9968 8.41637 13.8981 8.17608 13.722 7.99813L7.91929 2.19539C7.8099 2.08597 7.66632 2.01851 7.51369 2.00334L7.44794 2.00008H2.66669ZM5.00002 4.00008C5.5523 4.00008 6.00002 4.4478 6.00002 5.00008C6.00002 5.55237 5.5523 6.00008 5.00002 6.00008C4.44774 6.00008 4.00002 5.55237 4.00002 5.00008C4.00002 4.4478 4.44774 4.00008 5.00002 4.00008Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_23849_22603">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
